var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNflxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E60814;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M281.7,343.1v195h-35.6l-84.9-122.8h-1.4v122.8h-41.2v-195h36.2l84.2,122.7h1.7V343.1H281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306,538.1v-195h129.1v34h-87.9v46.5h79.3v34h-79.3v80.6H306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.2,538.1v-195h41.2v161h83.6v34H453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M634.4,343.1l39.3,66.5h1.5l39.5-66.5h46.6l-59.5,97.5l60.9,97.5h-47.4l-40-66.6h-1.5l-40,66.6h-47.2l61-97.5 l-59.9-97.5H634.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNflxIcon);
export default __webpack_public_path__ + "static/media/nflx_icon.58bc2515d72652746751584f1a3989da.svg";
export { ForwardRef as ReactComponent };